import { memo } from 'react';
// 192px-Fassung (3x die größte Anzeige von 56/64px) statt des 1024er
// Originals mit 128 KB (Okt 2026). Das Logo selbst ist unverändert (CD §6).
import OtterLogoImage from '../../assets/LOGO-192.png';
import { useTheme } from '../../contexts/ThemeContext';

const OtterLogo = ({ onClick, className = '' }) => {
  // Dasselbe feine Linien-Logo im Dark Mode nur weiß einfärben (statt einer
  // wuchtigen gefüllten Silhouette) – die zarten Linien bleiben erhalten.
  const { isDark } = useTheme();

  return (
    <div
      onClick={onClick}
      className={`relative group flex items-center justify-center ${className}`}
    >
      {/* Logo Image */}
      <img
        src={OtterLogoImage}
        alt="Otter Logo"
        width={56}
        height={56}
        decoding="async"
        className="w-12 h-12 md:w-14 md:h-14 transition-transform duration-200 group-hover:scale-105"
        style={{
          imageRendering: 'auto',
          WebkitImageRendering: 'auto',
          objectFit: 'contain',
          // brightness(0) -> schwarze Linien, invert(1) -> weiß; Alpha (feine
          // Linienführung) bleibt erhalten. Leicht gedämpft für dezenteren Look.
          filter: isDark ? 'brightness(0) invert(1)' : 'none',
          opacity: isDark ? 0.92 : 1
        }}
      />
      {/* Kein Hover-Glow: CD v2.0 (kein Glow, keine farbigen Schatten). Das Logo
          wird nie eingefaerbt, beim Hover waechst es nur leicht (scale-105). */}
    </div>
  );
};

export default memo(OtterLogo);